// extracted by mini-css-extract-plugin
module.exports = {"comments":"comments_comments__w4n8O","comments__title":"comments_comments__title__SeUq2","comments__form":"comments_comments__form___Jf27"};